/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Save_Settings_LabelInputs */

const en_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save CLI tool settings`)
};

const fr_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres des outils CLI`)
};

const de_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI-Tool-Einstellungen speichern`)
};

const it_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le impostazioni dello strumento CLI`)
};

const ru_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение настроек инструмента командной строки`)
};

const es_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar la configuración de la herramienta CLI`)
};

const zh_cn2_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存 CLI 工具设置`)
};

const ja_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLIツールの設定を保存する`)
};

const hi_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI टूल सेटिंग्स सहेजें`)
};

const pt_pt2_options_cli_save_settings_label = /** @type {(inputs: Options_Cli_Save_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar configurações da ferramenta CLI`)
};

/**
* | output |
* | --- |
* | "Save CLI tool settings" |
*
* @param {Options_Cli_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_save_settings_label = /** @type {((inputs?: Options_Cli_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_save_settings_label(inputs)
	if (locale === "de") return de_options_cli_save_settings_label(inputs)
	if (locale === "it") return it_options_cli_save_settings_label(inputs)
	if (locale === "ru") return ru_options_cli_save_settings_label(inputs)
	if (locale === "es") return es_options_cli_save_settings_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_save_settings_label(inputs)
	if (locale === "ja") return ja_options_cli_save_settings_label(inputs)
	if (locale === "hi") return hi_options_cli_save_settings_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_save_settings_label(inputs)
	return en_options_cli_save_settings_label(inputs)
});